import { DataService } from './core/data.service';
import { UpdateService } from './core/update.service';
import { Component } from '@angular/core';

@Component({
  selector: 'game-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'game';
  constructor(private updateService: UpdateService, private dataService: DataService) { }
}



// WEBPACK FOOTER //
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/app.component.ts